import { render } from "./AboutSection.vue?vue&type=template&id=2e9ef59e&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=2e9ef59e&lang=css&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9ef59e"]])

export default __exports__